import _export from "../internals/export";
import _dateToIsoString from "../internals/date-to-iso-string";
var $ = _export;
var toISOString = _dateToIsoString;

// `Date.prototype.toISOString` method
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit has a broken implementations
$({
  target: "Date",
  proto: true,
  forced: Date.prototype.toISOString !== toISOString
}, {
  toISOString: toISOString
});
export default {};